(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("JSZip"), require("localforage"));
	else if(typeof define === 'function' && define.amd)
		define(["JSZip", "localforage"], factory);
	else if(typeof exports === 'object')
		exports["ePub"] = factory(require("JSZip"), require("localforage"));
	else
		root["ePub"] = factory(root["JSZip"], root["localforage"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__6838__, __WEBPACK_EXTERNAL_MODULE__6361__) => {
return 